module.exports = __webpack_public_path__ + "fonts/icomoon.658e840d.eot";